import script from "./JournalThreadTags.vue?vue&type=script&setup=true&lang=js"
export * from "./JournalThreadTags.vue?vue&type=script&setup=true&lang=js"

import "./JournalThreadTags.vue?vue&type=style&index=0&id=07a42ad5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07a42ad5"]])

export default __exports__